/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Changes_HeaderInputs */



/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Compare_Event_Groups_Csv_Changes_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_changes_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Changes_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Changes_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambiamenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("变化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更点")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिवर्तन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mudanças")
	return /** @type {LocalizedString} */ ("Changes")
});